"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPriceError = void 0;
const big_1 = __importDefault(require("@swyftx/big"));
const types_1 = require("../types");
const generalUtils_1 = require("./generalUtils");
const getPriceError = (direction, type, value, limitingPrice, precisionLimit) => {
    if (!value)
        return undefined;
    const { isLong, isShort, isLimitOrder, isStopOrder } = (0, generalUtils_1.distilMarginInformation)(direction, type);
    if ((0, big_1.default)(value).eq(0))
        return types_1.PriceError.PriceIsZero;
    if ((0, generalUtils_1.isExceedingPrecision)((0, big_1.default)(limitingPrice).toString(), precisionLimit))
        return types_1.PriceError.TooMuchPrecision;
    if (isLong && isLimitOrder && (0, big_1.default)(value).gte(limitingPrice))
        return types_1.PriceError.LimitPriceAboveBuy;
    if (isLong && isStopOrder && (0, big_1.default)(value).lte(limitingPrice))
        return types_1.PriceError.StopPriceBelowBuy;
    if (isShort && isLimitOrder && (0, big_1.default)(value).lte(limitingPrice))
        return types_1.PriceError.LimitPriceBelowSell;
    if (isShort && isStopOrder && (0, big_1.default)(value).gte(limitingPrice))
        return types_1.PriceError.StopPriceAboveSell;
    return undefined;
};
exports.getPriceError = getPriceError;
//# sourceMappingURL=priceErrors.js.map